import React from 'react';
import { Users, ShieldCheck, Leaf, Award } from 'lucide-react';
export function TrustBar() {
  return <section className="w-full py-8 px-4 bg-forest text-cream-card border-y-4 border-forest-light" data-id="element-123">
      <div className="max-w-5xl mx-auto" data-id="element-124">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 text-center" data-id="element-125">
          <div className="flex flex-col items-center gap-2" data-id="element-126">
            <Users className="w-8 h-8 opacity-90" data-id="element-127" />
            <span className="font-serif text-sm md:text-base font-medium" data-id="element-128">
              80.000+ zufriedene Kunden
            </span>
          </div>
          <div className="flex flex-col items-center gap-2" data-id="element-129">
            <Award className="w-8 h-8 opacity-90" data-id="element-130" />
            <span className="font-serif text-sm md:text-base font-medium" data-id="element-131">
              Von Tierärzten empfohlen
            </span>
          </div>
          <div className="flex flex-col items-center gap-2" data-id="element-132">
            <Leaf className="w-8 h-8 opacity-90" data-id="element-133" />
            <span className="font-serif text-sm md:text-base font-medium" data-id="element-134">
              100% pflanzlich & natürlich
            </span>
          </div>
          <div className="flex flex-col items-center gap-2" data-id="element-135">
            <ShieldCheck className="w-8 h-8 opacity-90" data-id="element-136" />
            <span className="font-serif text-sm md:text-base font-medium" data-id="element-137">
              Geld-zurück-Garantie
            </span>
          </div>
        </div>
      </div>
    </section>;
}